export const passwordScore = 2;
